;(function(window, APP, _) {
	'use strict';

	var ChecksumEmitter = (function() {
		var
			instance, _last_date,
			_checksums, _new_checksums,

			EXPIRED_SEC = 5,

			config      = {
				wait_sec: 60
			}
		;

		function initialize() {
			var interval = config.wait_sec * 1000;

			setInterval(_.bind(this.requestChecksum, this), interval);
		}

		function rememberChecksums(checksums) {
			_new_checksums = checksums;
		}

		function clearRememberedChecksums() {
			_checksums = _new_checksums;
			_new_checksums = undefined;
		}

		function diffChecksums(hash, key) {
			return _checksums[key] !== hash;
		}

		function publishDiff(response) {
			var
				trigger  = _.bind(triggerChanges, this),
				diffKeys = this.getDiffKeys(response)
			;

			if (_.size(diffKeys)) {
				trigger(_, diffKeys);
			}

			_.each(diffKeys, trigger);

			if (!this.getChecksum()) {
				this.setChecksum(response);
			}
		}

		function triggerChanges(key, args, object) {
			var evt_type = (!_.isUndefined(key) && _.isString(key)) ? (':' + key) : '';

			// Possible events:
			// "gameweeks", "squads", "supported_clubs", "venues", "countries", "competitions", "players"

			this.trigger('change' + evt_type, args, object);
		}

		function ChecksumEmitterConstructor() {
			if (instance) {
				return instance;
			}

			if (this && this.constructor === ChecksumEmitterConstructor) {
				instance = this;
			}
			else {
				return new ChecksumEmitterConstructor();
			}

			_.bind(initialize, this)();
		}

		function isExpired() {
			var
				now        = _.now() + 1,
				old        = _last_date || _.now(),
				is_expired = ((now - old) / 1000) >= EXPIRED_SEC
			;

			_last_date = now;

			return is_expired;
		}

		_.extend(ChecksumEmitterConstructor.prototype, Backbone.Events, {
			makeRequest:     function() {
				var URL = CONFIG.JSON_SPORT_URL + 'checksums.json?_' + _.now();
				
				if (isExpired()) {
					clearRememberedChecksums();

					return $.get(URL).done(rememberChecksums);
				}
				else {
					return $.Deferred(function(dfr) {
						dfr.resolve(_new_checksums);
					}).promise();
				}
			},
			requestChecksum: function() {
				if (this.hasSubscribers()) {
					this.makeRequest().done(_.bind(publishDiff, this));
				}
			},
			hasSubscribers:  function() {
				var
					keys = _.keys(this._listeners),
					size = _.size(keys)
				;
				return Boolean(size);
			},
			getDiffKeys:     function(checksums) {
				var
					diffObj  = {},
					diffKeys = []
				;

				if (_checksums) {
					diffObj = _.pick(checksums, diffChecksums);
					diffKeys = _.keys(diffObj)
				}

				return diffKeys;
			},
			getChecksum:     function(new_checksums) {
				return _checksums;
			},
			setChecksum:     function(new_checksums) {
				_checksums = new_checksums;
			}
		});

		return ChecksumEmitterConstructor;
	}());

	APP.ChecksumEmitter = ChecksumEmitter;

})(window, APP, _);